import { css } from "@emotion/react";
import React from "react";
import BoardTargetsSummary from "./board-targets-summary";

type TProps = {
  doneCount: number;
  wipCount: number;
  cardsWithTargetsCount: number;
  allCardsCount: number;
  removedCardsCount: number;
  unauthorizedCardsCount: number;
  boardsCount: number;
};

const Summary = (props: TProps) => {
  const unavailable = props.removedCardsCount + props.unauthorizedCardsCount;
  const unavailableHelp = `cards removed: ${props.removedCardsCount}\ncards without authorization to view: ${props.unauthorizedCardsCount}`;
  return (
    <div css={styles.container}>
      <div css={styles.section}>
        <span>Boards: {props.boardsCount}</span>
        <span>
          Cards: {props.allCardsCount}
          <span css={styles.helpCursor} title={unavailableHelp}>
            {unavailable > 0 ? ` (${unavailable} unavailable)` : ""}
          </span>
        </span>
      </div>
      <div css={styles.section}>
        <span css={styles.targets}>
          Progress:&nbsp;&nbsp;
          <BoardTargetsSummary
            doneCount={props.doneCount}
            wipCount={props.wipCount}
            cardsCount={props.cardsWithTargetsCount}
          />
        </span>
      </div>
    </div>
  );
};

export default React.memo(Summary);

const styles = {
  container: css`
    display: flex;
    justify-content: space-between;
    padding: 0 0 8px 0;
    font-weight: 600;
    flex-wrap: wrap;
  `,
  section: css`
    display: flex;
    & > * {
      margin: 0 8px;
    }
  `,
  targets: css`
    display: flex;
    flex-wrap: wrap;
  `,
  helpCursor: css`
    cursor: help;
  `,
};
